import { Card } from "@mui/material";

import { Loading } from "@/components/loading";

export const EmManualControlCardLoadingTemplate = () => (
	<Card variant="outlined">
		<Loading data-testid="em-manual-control-card__loading__machine" />
	</Card>
);
